if (!window.dAgency) window.dAgency = {};
if (!window.dAgency.media) window.dAgency.media = {};

window.dAgency.media.firstModelLoaded = false;
window.dAgency.media.firstVideoLoaded = false;

window.dAgency.media.firtsModelPrep = (el) => {
  if (window.dAgency.media.firstModelLoaded) return;

  var tag = document.createElement('link');
  tag.id = 'ShopifyModelStyleTag';
  tag.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
  tag.rel = 'stylesheet';
  tag.type = 'text/css';
  document.querySelector('head').prepend(tag);

  window.Shopify.loadFeatures([{
    name: 'model-viewer-ui',
    version: '1.0',
    onLoad: () => {
      window.dAgency.media.firstModelLoaded = true;
      window.dAgency.media.initModel(el);
    }
  }]);
};

window.dAgency.media.firtsVideoPrep = (el) => {
  if (window.dAgency.media.firstVideoLoaded) return;

  var tag = document.createElement('link');
  tag.id = 'ShopifyPlyrStyleTag';
  tag.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
  tag.rel = 'stylesheet';
  tag.type = 'text/css';
  document.querySelector('head').prepend(tag);

  window.Shopify.loadFeatures([{
    name: 'video-ui',
    version: '1.0',
    onLoad: () => {
      window.dAgency.media.firstVideoLoaded = true;
      window.dAgency.media.initVideo(el);
    }
  }]);
};

window.dAgency.media.initModel = (el) => {
  if (!window.dAgency.media.firstModelLoaded) {
    window.dAgency.media.firtsModelPrep(el);
    return;
  }

  if (el.tagName !== 'MODEL-VIEWER') return;
  new window.Shopify.ModelViewerUI(el);
};

window.dAgency.media.initVideo = (el) => {
  if (!window.dAgency.media.firstVideoLoaded) {
    window.dAgency.media.firtsVideoPrep(el);
    return;
  }

  if (el.tagName !== 'VIDEO') return;
  new window.Shopify.Plyr(el);
};

document.addEventListener('DOMContentLoaded', () => {
  const mediaJS = document.querySelectorAll('.init-js-media');
  if (!mediaJS.length) return;

  mediaJS.forEach(el => {
    if (el.classList.contains('media-video')) {
      window.dAgency.media.initVideo(el);
    } else if (el.classList.contains('media-model')) {
      window.dAgency.media.initModel(el);
    }
  });
});
